'use client';

import { PopupList, useModal } from '@payloadcms/ui';

import { EXPORT_JOURNEY_MODAL_SLUG } from '../Modals/ExportModal/ExportModal';

const ExportButton = ({ disabled }: { disabled: boolean }) => {
  const { openModal } = useModal();

  return (
    <>
      <PopupList.Button
        disabled={disabled}
        onClick={() => {
          openModal(EXPORT_JOURNEY_MODAL_SLUG);
        }}
      >
        Export
      </PopupList.Button>
    </>
  );
};

export default ExportButton;
